export default "__VITE_ASSET__BCEw0A5S__"